import React from 'react';

import { Divider } from 'antd';

import { Form } from 'common/components';
import SupplementNutrientItem from './SupplementNutrientItem';
import { WrapperSupplementDailyField } from '../../../multiple-panel/facts-panel/overlay/WrapperNutrient';

import { useCheckIsProductOverlay } from 'hooks/product';

const OVERLAY_DAILY_FIELD = {};

const SupplementNutrientList = (props) => {
  const form = Form.useFormInstance();

  const { fieldName, remove, mode, setMode, originNutrients } = props;

  const nutrientList = Form.useWatch(fieldName, form);

  const isProductOverlay = useCheckIsProductOverlay();

  const getNutrientRendererList = () => {
    return nutrientList?.map((nutrient, index) => {
      return {
        ...nutrient,
        isEdit: mode === `edit-${index}`,
      };
    });
  };

  const nutrientRendererList = getNutrientRendererList();

  return nutrientRendererList?.length ? (
    <div style={{ padding: '0px 4px' }}>
      {nutrientRendererList?.map((nutrientItem, index) => {
        const originNutrient =
          originNutrients?.find((item) => item?.path === nutrientItem?.path) ||
          OVERLAY_DAILY_FIELD;

        const originValue =
          JSON.stringify(nutrientList[index]) !==
            JSON.stringify(originNutrient) && isProductOverlay
            ? originNutrient
            : null;

        return (
          <WrapperSupplementDailyField
            originValue={originValue}
            fieldName={fieldName}
          >
            <SupplementNutrientItem
              fieldName={fieldName}
              data={nutrientItem}
              setMode={setMode}
              remove={remove}
              key={index}
              index={index}
            />
          </WrapperSupplementDailyField>
        );
      })}
      <Divider style={{ margin: '8px 0px 0px' }} />
    </div>
  ) : null;
};

export default SupplementNutrientList;
